



























































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateModal from "./createallocationrules.vue";
import EditModal from "./editallocationrules.vue";
import moment from "moment-timezone";
import SearchTree from "@/lib/Common/searchtree";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageAllocationRulesRequest extends PageRequest {
  keyword: string;
  areaId: number;
  isEnabel: number = 9; //nullable
}

@Component({
  components: { CreateModal, EditModal },
})
export default class AllocationRules extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  async edit(id: string) {
    let res = await this.$store
      .dispatch({
        type: "allocationrules/get",
        id: id,
      })
      .catch((err) => {
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.$store.commit("allocationrules/edit", res);
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageAllocationRulesRequest = new PageAllocationRulesRequest();
  creationTime: Date[] = [];
  columnlist: any[] = [];
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  showcolumn: boolean = false; //显示列选择窗口
  splitnum: number = 0.15;

  get list() {
    return this.$store.state.allocationrules.list;
  }
  get loading() {
    return this.$store.state.allocationrules.loading;
  }
  create() {
    this.createModalShow = true;
  }
  showcol() {
    this.showcolumn = true;
  }
  isActiveChange(val: number) {
    this.pagerequest.isEnabel = val;
    this.$store.commit("allocationrules/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("allocationrules/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  pageChange(page: number) {
    this.$store.commit("allocationrules/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("allocationrules/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "allocationrules/getAllAllocationRules",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.allocationrules.pageSize;
  }
  get totalCount() {
    return this.$store.state.allocationrules.totalCount;
  }
  get currentPage() {
    return this.$store.state.allocationrules.currentPage;
  }
  //展开行
  onExpand(row, index) {
    this.list.forEach((item, i) => {
      //这个循环是为了每次只能展开一个，其他自动收起，不需要可以去掉
      i !== index ? (this.list[i]._expanded = false) : "";
    });
    this.list[index]._expanded = !this.list[index]._expanded;
    this.list.sort();
  }
  columns = [
    {
      type: "index",
      width: 70,
      align: "center",
      fixed: "left",
      title: this.L("IndexNo"),
      sortId: 0,
    },
    {
      title: this.L("Name"),
      key: "name",
      sortable: true,
    },
    {
      type: "expand",
      width: 30,
      render: (h, params) => {
        return h("div", [
          h("Table", {
            props: {
              columns: [
                {
                  type: "index",
                  width: 80,
                  align: "left",
                  title: this.L("IndexNo"),
                },
                {
                  title: this.L("Areas"),
                  key: "areaName",
                  sortable: true,
                  width: 130,
                  render: (h: any, params: any) => {
                    return h(
                      "span",
                      {
                        style: {
                          display: "inline-block",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        },
                        domProps: {
                          title: params.row.areaName,
                        },
                      },
                      params.row.areaName
                    );
                  },
                },
                {
                  title: this.L("Meter"),
                  key: "meterNo",
                  sortable: true,
                  width: 180,
                  render: (h: any, params: any) => {
                    return h(
                      "span",
                      {
                        style: {
                          display: "inline-block",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        },
                        domProps: {
                          title: params.row.meterNo,
                        },
                      },
                      params.row.meterNo
                    );
                  },
                },
                {
                  title: this.L("RoomNo"),
                  key: "roomNo",
                  width: 150,
                  sortable: true,
                  render: (h: any, params: any) => {
                    return h(
                      "span",
                      {
                        style: {
                          display: "inline-block",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        },
                        domProps: {
                          title: params.row.roomNo,
                        },
                      },
                      params.row.roomNo
                    );
                  },
                },
                {
                  title: this.L("ControleType"),
                  key: "controleType",
                  width: 130,
                  sortable: true,
                  sortId: 3,
                  render: (h: any, params: any) => {
                    let id = params.row.controleType;
                    let ite = JSON.parse(localStorage.getItem("itemdetail"));
                    let info = ite.filter((p) => {
                      return p.id == id;
                    });
                    return h("span", info.length > 0 ? info[0].name : "未知");
                  },
                },
                {
                  title: this.L("ReadTime"),
                  key: "lastReadTime",
                  width: 150,
                  sortable: true,
                  render: (h: any, params: any) => {
                    return h(
                      "span",
                      params.row.lastReadTime == null
                        ? ""
                        : moment(params.row.lastReadTime).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )
                    );
                  },
                },
                {
                  title: this.L("LastReadNum"),
                  key: "lastReadNum",
                  width: 150,
                  sortable: true,
                },
                {
                  title: this.L("CurrentTenant"),
                  key: "customerName",
                  sortable: true,
                  width: 150,
                  render: (h: any, params: any) => {
                    return h(
                      "span",
                      {
                        style: {
                          display: "inline-block",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        },
                        domProps: {
                          title: params.row.customerName,
                        },
                      },
                      params.row.customerName
                    );
                  },
                },
                {
                  title: this.L("Location"),
                  key: "location",
                  sortable: true,
                  width: 130,
                  render: (h: any, params: any) => {
                    return h(
                      "span",
                      {
                        style: {
                          display: "inline-block",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        },
                        domProps: {
                          title: params.row.location,
                        },
                      },
                      params.row.location
                    );
                  },
                },
              ], //表头
              data: params.row.allocationedDevice, //内部表格展示的数据
            },
          }), //我这里使用的是表格，大家也可以根据自己的实际情况更换别的组件
          h("Table", {
            props: {
              columns: [
                {
                  type: "index",
                  width: 80,
                  align: "left",
                  title: this.L("IndexNo"),
                },
                {
                  title: this.L("Areas"),
                  key: "areaName",
                  sortable: true,
                  width: 130,
                  render: (h: any, params: any) => {
                    return h(
                      "span",
                      {
                        style: {
                          display: "inline-block",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        },
                        domProps: {
                          title: params.row.areaName,
                        },
                      },
                      params.row.areaName
                    );
                  },
                },
                {
                  title: this.L("Meter"),
                  key: "meterNo",
                  sortable: true,
                  width: 180,
                  render: (h: any, params: any) => {
                    return h(
                      "span",
                      {
                        style: {
                          display: "inline-block",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        },
                        domProps: {
                          title: params.row.meterNo,
                        },
                      },
                      params.row.meterNo
                    );
                  },
                },
                {
                  title: this.L("RoomNo"),
                  key: "roomNo",
                  width: 150,
                  sortable: true,
                  render: (h: any, params: any) => {
                    return h(
                      "span",
                      {
                        style: {
                          display: "inline-block",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        },
                        domProps: {
                          title: params.row.roomNo,
                        },
                      },
                      params.row.roomNo
                    );
                  },
                },
                {
                  title: this.L("ControleType"),
                  key: "controleType",
                  width: 130,
                  sortable: true,
                  sortId: 3,
                  render: (h: any, params: any) => {
                    let id = params.row.controleType;
                    let ite = JSON.parse(localStorage.getItem("itemdetail"));
                    let info = ite.filter((p) => {
                      return p.id == id;
                    });
                    return h("span", info.length > 0 ? info[0].name : "未知");
                  },
                },
                {
                  title: this.L("ReadTime"),
                  key: "lastReadTime",
                  width: 150,
                  sortable: true,
                  render: (h: any, params: any) => {
                    return h(
                      "span",
                      params.row.lastReadTime == null
                        ? ""
                        : moment(params.row.lastReadTime).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )
                    );
                  },
                },
                {
                  title: this.L("LastReadNum"),
                  key: "lastReadNum",
                  width: 150,
                  sortable: true,
                },
                {
                  title: this.L("CurrentTenant"),
                  key: "customerName",
                  sortable: true,
                  width: 150,
                  render: (h: any, params: any) => {
                    return h(
                      "span",
                      {
                        style: {
                          display: "inline-block",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        },
                        domProps: {
                          title: params.row.customerName,
                        },
                      },
                      params.row.customerName
                    );
                  },
                },
                {
                  title: this.L("Location"),
                  key: "location",
                  sortable: true,
                  width: 130,
                  render: (h: any, params: any) => {
                    return h(
                      "span",
                      {
                        style: {
                          display: "inline-block",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        },
                        domProps: {
                          title: params.row.location,
                        },
                      },
                      params.row.location
                    );
                  },
                },
              ], //表头
              data: params.row.bearsDevice, //内部表格展示的数据
            },
          }), //我这里使用的是表格，大家也可以根据自己的实际情况更换别的组件
        ]);
      },
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].displayName : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].displayName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("AllocationRules"),
      key: "rules",
      sortable: true,
      render: (h: any, params: any) => {
        let str = this.L("AreasAllocation");
        if (params.row.rules == 2) {
          str = this.L("UseAllocation");
        }
        return h("span", str);
      },
    },
    {
      title: this.L("IsActive"),
      key: "isEnable",
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("Description"),
      key: "description",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.description,
            },
          },
          params.row.description
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('allocationrulesDel');
        let edit = this.checkButtonAuth('allocationrulesEdit');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.edit(params.row.id);
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "allocationrules/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
    this.pagerequest.isEnabel = 9;
    this.getAreaTree();
  }
  data() {
    return {
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
